export const doFetch = async (url, extras) => {
    if (url.error) return url;

    try {
        const response = await fetch(url, {
            credentials: "include",
            ...extras,
        });

        if (!response) {
            return { error: "No response" };
        }

        // Check if the response status indicates an error
        if (!response.ok) {
            // This checks for status codes outside the 2xx range
            const errorBody = await response.json();

            // Handle specific status codes if needed
            if (response.status === 401 && errorBody.error === "Sid or cookie sid is required") {
                qModEvent({ type: "AUTH", event: "INVALID_SID" });
                return { error: "Please log in" };
            }

            // Return or throw an error message based on the response
            return { error: errorBody.error || response.statusText };
        }

        return await response.json();
    } catch (e) {
        console.error("Fetch error:", e);
        return { error: e };
    }
};
